export const visit = (vm, at) => {
vm(require("foundations-components/lang/af.lyaml"));
at({ "af": { "placeholder": "plekhouer" } });
};